import { CATEGORIES_MAPPING, SUB_CATEGORIES_MAPPING } from '../consts';
import type { Category, QuestionSelect, ReportType, SubCategory } from '../types';

/** Returns the corresponding sub categories or questions for any given category. */
export function getSubCategoriesOrQuestions(type: ReportType, category: Category): QuestionSelect {
	return CATEGORIES_MAPPING[type][category];
}

/** Returns the corresponding sub categories or questions for any given subcategory. */
export function getSubSubCategoriesOrQuestions(type: ReportType, subCategory: SubCategory): QuestionSelect {
	return SUB_CATEGORIES_MAPPING[type][subCategory];
}
